import { render, staticRenderFns } from "./TotalEditColumn.vue?vue&type=template&id=443998ea"
import script from "./TotalEditColumn.vue?vue&type=script&lang=ts"
export * from "./TotalEditColumn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('443998ea')) {
      api.createRecord('443998ea', component.options)
    } else {
      api.reload('443998ea', component.options)
    }
    module.hot.accept("./TotalEditColumn.vue?vue&type=template&id=443998ea", function () {
      api.rerender('443998ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/TotalEditColumn.vue"
export default component.exports